import { floor } from 'lodash-es';

/**
 * This is a helper function that formats a number greater or equal to 1000.
 * It return a float with 2 decimals and the character 'K' or 'M'
 *
 * @param {Integer} num
 * @returns {Object} with number and format attributes
 */

export function formatLongNumbers(num) {
    const obj = {
        number: num,
        format: num / 1.0e6 < 1 ? 'K' : 'M',
    };
    switch (obj.format) {
        case 'K':
            obj.number = floor(num / 1.0e3, 2);
            break;
        case 'M':
            obj.number = floor(num / 1.0e6, 2);
            break;
        default:
            obj.format = '';
    }
    return obj;
}
